import { useCallback, useState, useEffect, useRef } from "react";

import { ENV } from "../constants/env";
import Auth from "../libs/vendors/auth";

const useRecaptchaAction = (actionName = ENV.RECAPTCHA.DEFAULT_ACTION) => {
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [isLoadedGrecaptcha, setIsLoadedGrecaptcha] = useState(false);
    const verifyGrecaptchaInterval = useRef();
    const execute = useCallback(() => {
        const { grecaptcha } = window;
        if (ENV.RECAPTCHA.PUBLIC_KEY && grecaptcha) {
            grecaptcha
                .execute(ENV.RECAPTCHA.PUBLIC_KEY, { action: actionName })
                .then(token => {
                    setRecaptchaToken(token);
                    Auth.init();
                });
        }
    }, [actionName]);
    useEffect(() => {
        if (isLoadedGrecaptcha) {
            execute();
        }
    }, [execute, isLoadedGrecaptcha]);
    useEffect(() => {
        if (!isLoadedGrecaptcha && !verifyGrecaptchaInterval.current) {
            verifyGrecaptchaInterval.current = setInterval(() => {
                setIsLoadedGrecaptcha(!!window.grecaptcha && !!window.grecaptcha.execute);
            }, 50);
        }
        if (isLoadedGrecaptcha) {
            clearInterval(verifyGrecaptchaInterval.current);
        }
    }, [isLoadedGrecaptcha, verifyGrecaptchaInterval]);
    return { recaptchaToken, execute };
};

export default useRecaptchaAction;
